// 配置API接口地址
export default {
  // api接口地址
  root: process.env.API_ROOT,
  // 图片服务器接口地址
  upload: process.env.API_IMG_ROOT
}



// WEBPACK FOOTER //
// ./src/api/index.js